export function arr2Map<T, V = string>(arr: T[], keyName = 'symbol'): Map<V, T> {
  return arr.reduce((res, cur) => {
    res.set(cur[keyName], cur);
    return res;
  }, new Map());
}
